import React, { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import "../styles/Pricing.scss";

const Pricing = () => {
  const navigate = useNavigate();

  // When clicking "Get in touch", render the Contact component directly in Pricing
  const handleContactClick = () => {
    // Set a flag in session storage to show Contact component without scroll
    sessionStorage.setItem('showContact', 'true');
    // Navigate to the home page
    navigate('/');
  };

  return (
    <div className="pricing">
      <Navbar />
      <main className="pricing__main" id="main-content" aria-label="Pricing page content">
        <section className="pricing__hero-section" aria-labelledby="pricing-heading">
          <div className="pricing__container">
            <div className="pricing__header">
              <h1 id="pricing-heading" className="pricing__title">
                AccessiBridge <span className="pricing__title-accent">Pricing</span>
              </h1>
              <p className="pricing__subtitle">
                Choose the right accessibility solution for your organization
              </p>
            </div>

            <div className="pricing__grid">
              {/* Essentials */}
              <div className="pricing__card-wrapper">
              <div className="pricing__card">
                <div className="pricing__card-header">
                  <h2 className="pricing__card-title">AccessiBridge Essentials</h2>
                </div>
                <div className="pricing__card-content">
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Automated report</span>
                  </div>
                  <p className="pricing__card-description">
                    Our automated report identifies and categorizes up to 50% of accessibility issues
                  </p>
                    <div className="pricing__feature pricing__feature--price">
                      <Check className="pricing__feature-icon" />
                      <span className="pricing__feature-text pricing__feature-text--free">It's Free</span>
                    </div>
                </div>
                <Link to="/report" className="pricing__card-link">
                  <button className="pricing__button">Get it now</button>
                </Link>
                </div>
              </div>

              {/* Pro */}
              <div className="pricing__card-wrapper">
              <div className="pricing__card">                
                <div className="pricing__card-header">
                  <h2 className="pricing__card-title">AccessiBridge Pro</h2>
                </div>
                <div className="pricing__card-content">
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Automated report</span>
                  </div>
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Remediation Blueprint</span>
                  </div>
                  <p className="pricing__card-description">
                    Includes detailed report with technical insights for developers and content managers
                  </p>
                    <div className="pricing__feature pricing__feature--price">
                      <Check className="pricing__feature-icon" />
                      <span className="pricing__feature-text">
                        <span className="pricing__price-amount">From 299,00€</span>
                        <span className="pricing__price-unit"> / Content Page</span>
                      </span>
                    </div>
                </div>
                <div className="pricing__card-link">
                  <button onClick={handleContactClick} className="pricing__button">Get in touch</button>
                  </div>
                </div>
              </div>

              {/* Ultimate */}
              <div className="pricing__card-wrapper">
              <div className="pricing__card">
                <div className="pricing__badge">
                  Popular
                </div>
                <div className="pricing__card-header">
                  <h2 className="pricing__card-title">AccessiBridge Ultimate</h2>
                </div>
                <div className="pricing__card-content">
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Automated report</span>
                  </div>
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Remediation Blueprint</span>
                  </div>
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Expert Audit</span>
                  </div>
                  <p className="pricing__card-description">
                    Comprehensive expert-led audit ensuring 100% of accessibility issues are identified
                  </p>
                </div>
                <div className="pricing__card-link">
                  <button onClick={handleContactClick} className="pricing__button">Get in touch</button>
                  </div>
                </div>
              </div>

              {/* Continuity */}
              <div className="pricing__card-wrapper">
              <div className="pricing__card">
                <div className="pricing__card-header">
                  <h2 className="pricing__card-title">AccessiBridge Continuity</h2>
                </div>
                <div className="pricing__card-content">
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">All Ultimate features</span>
                  </div>
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Regular updates</span>
                  </div>
                  <div className="pricing__feature">
                    <Check className="pricing__feature-icon" />
                    <span className="pricing__feature-text">Remediation Implementation</span>
                  </div>
                  <p className="pricing__card-description">
                    Complete accessibility management with expert team support
                  </p>
                </div>
                <div className="pricing__card-link">
                  <button onClick={handleContactClick} className="pricing__button">Get in touch</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing; 